/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 购票后获取应增加的成长值
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  ticketPurchaseGrowthValueReq: member.TicketPurchaseGrowthValueReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: number;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/ticket-growth`,
    data: ticketPurchaseGrowthValueReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
